// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOneTimeLinkResponseDto
 */
export interface IOneTimeLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IOneTimeLinkResponseDto
     */
    hash_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IOneTimeLinkResponseDto
     */
    link?: string;
    /**
     * 
     * @type {number}
     * @memberof IOneTimeLinkResponseDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOneTimeLinkResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOneTimeLinkResponseDto
     */
    document_id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof IOneTimeLinkResponseDto
     */
    file_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof IOneTimeLinkResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOneTimeLinkResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IOneTimeLinkResponseDto
     */
    active?: boolean;
}

/**
 * Check if a given object implements the IOneTimeLinkResponseDto interface.
 */
export function instanceOfIOneTimeLinkResponseDto(value: object): value is IOneTimeLinkResponseDto {
    return true;
}

export function IOneTimeLinkResponseDtoFromJSON(json: any): IOneTimeLinkResponseDto {
    return IOneTimeLinkResponseDtoFromJSONTyped(json, false);
}

export function IOneTimeLinkResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOneTimeLinkResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hash_id': json['hash_id'] == null ? undefined : json['hash_id'],
        'link': json['link'] == null ? undefined : json['link'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'file_ids': json['file_ids'] == null ? undefined : json['file_ids'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function IOneTimeLinkResponseDtoToJSON(json: any): IOneTimeLinkResponseDto {
    return IOneTimeLinkResponseDtoToJSONTyped(json, false);
}

export function IOneTimeLinkResponseDtoToJSONTyped(value?: IOneTimeLinkResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hash_id': value['hash_id'],
        'link': value['link'],
        'claim_id': value['claim_id'],
        'employee_id': value['employee_id'],
        'document_id': value['document_id'],
        'file_ids': value['file_ids'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'active': value['active'],
    };
}

